import React, { useState } from 'react'
import ChatBubble from './ChatBubble'
import axios from 'axios'

function ChatWidget() {
  const [open, setOpen] = useState(false)
  const [input, setInput] = useState('')
  const [messages, setMessages] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  const handleSend = async (e) => {
    e?.preventDefault?.()
    if (!input.trim()) return

    const userMessage = { text: input, from: 'user' }
    setMessages((prev) => [...prev, userMessage])
    setInput('')
    setIsLoading(true)

    try {
      const res = await axios.post('/api/chat/query', { query: input })
      const finalText = res.data || 'Sorry, something went wrong. Please try again later.'
      setMessages((prev) => [...prev, { text: finalText, from: 'bot' }])
    } catch (error) {
      setMessages((prev) => [
        ...prev,
        { text: 'Sorry, something went wrong. Please try again later.', from: 'bot' },
      ])
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <>
      <div className="fixed bottom-6 right-6 z-50">
        {!open && (
          <button
            className="p-5 rounded-full bg-blue-600 text-white shadow-lg hover:bg-blue-700"
            onClick={() => setOpen(true)}
            data-testid="chat-widget-button"
          >
            💬
          </button>
        )}
      </div>

      {/* Chatbox */}
      {open && (
        <div className="fixed bottom-6 right-6 w-[400px] h-[600px] bg-white border shadow-lg flex flex-col z-50">
          <div className="flex justify-between items-center px-4 py-2 border-b bg-blue-600 text-white">
            <h3 className="text-sm font-semibold">Chatbot Assistant</h3>
            <button onClick={() => setOpen(false)}>✖️</button>
          </div>

          <div className="flex-1 p-3 overflow-y-auto">
            {messages.map((msg, i) => (
              <ChatBubble key={i} message={msg.text} from={msg.from} />
            ))}

            {isLoading && (
              <ChatBubble
                message={
                  <span className="inline-flex gap-1">
                    <span className="animate-bounce delay-0">.</span>
                    <span className="animate-bounce delay-150">.</span>
                    <span className="animate-bounce delay-300">.</span>
                  </span>
                }
                from="bot"
              />
            )}
          </div>

          <form onSubmit={handleSend} className="flex border-t p-2">
            <input
              type="text"
              className="flex-1 px-2 py-1 border rounded mr-2"
              value={input}
              onChange={(e) => setInput(e.target.value)}
              placeholder="Ask something..."
            />
            <button
              type="submit"
              className={`bg-blue-600 text-white px-3 py-1 rounded ${
                isLoading ? 'opacity-50 cursor-not-allowed' : ''
              }`}
              disabled={isLoading}
            >
              Send
            </button>
          </form>
        </div>
      )}
    </>
  )
}
export { ChatWidget }
